import { NotificationConfiguration } from '../notification.templates';

export const RACI_WEEK_BEFORE_REMINDER: NotificationConfiguration = {
  inapp: `A report is due soon.`,
  email: {
    ctaKey: 'check_in_report',
  },
};
